<template>
	<!-- アレルギー情報 -->
	<div class="allergenInfo" v-if="ptInitData.productInfo.ALLERGEN_DISP_KBN != 0">
		<dl class="allergenRow">
			<dt class="allergenTitle">
				{{ $t('pt125.labels.allergenInfo') }}
			</dt>
			<dd class="allergenData">
				<!-- 情報なし（現在調査中） -->
				<template v-if="ptInitData.productInfo.ALLERGEN_DISP_KBN == 2">{{
					$t('pt125.labels.allergenInfoInvestigation') }}</template>
				<!-- 情報あり（アレルゲンあり） -->
				<template v-else-if="ptInitData.productInfo.ALLERGEN_KBN">{{ allergenStr }}</template>
				<!-- 情報あり（アレルゲンなし） -->
				<template v-else>{{ $t('pt125.labels.allergenInfoNone') }}</template>
			</dd>
		</dl>
	</div>
</template>
<script>

export default {
	name: 'AllergenInfo',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		allergenStr: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
		}
	},
	mounted() {
	}
}
</script>